import {
    GET_CONFIG_FORM29,
    GET_DATOS_SOLICITUD,
    GET_COMBO_APROBACION,
    POST_PROCESAR_ATENDER
} from '../types';


export default function atenderSolicitudReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM29:
            return { ...state, cfg_form29:action.payload }
        case GET_DATOS_SOLICITUD:
            return { ...state, datosSolicitudDescuento:action.payload }
        case GET_COMBO_APROBACION:
            return { ...state, comboAprobacion:action.payload }
        case POST_PROCESAR_ATENDER:
            return { ...state, respuestaProcesar:action.payload }
        
        
       
       
        default:
            return state
    }
}